/**
 * km-cart-griff.js – Schritt 186
 * Fügt im Warenkorb (Drawer + Warenkorbseite) den kompatiblen Rasierergriff hinzu,
 * wenn Fusion5-Klingen im Warenkorb liegen. Gleiche Mechanik wie km-griff-addon.js:
 * Shopify AJAX Cart API + Theme-Event (CartLinesUpdateEvent), damit Drawer, Summen
 * und Warenkorb-Symbol automatisch neu gerendert werden.
 */
(async () => {
  if (window.__kmCartGriff) return;
  window.__kmCartGriff = true;

  let CartLinesUpdateEvent;
  let CartErrorEvent;
  try {
    const events = await import('@shopify/events');
    CartLinesUpdateEvent = events.CartLinesUpdateEvent;
    CartErrorEvent = events.CartErrorEvent;
  } catch (err) {
    console.warn('[km-cart-griff] @shopify/events nicht verfügbar – Seite wird nach dem Hinzufügen neu geladen.', err);
  }

  const addUrl = () =>
    typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url ? Theme.routes.cart_add_url : '/cart/add.js';
  const cartUrl = () =>
    typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url ? `${Theme.routes.cart_url}.js` : '/cart.js';
  const sectionIds = () => {
    const ids = new Set();
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) ids.add(el.dataset.sectionId);
    });
    return Array.from(ids);
  };

  async function addGriff(variantId) {
    let deferred = null;
    if (CartLinesUpdateEvent) {
      deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'cart',
          lines: [{ merchandiseId: variantId, quantity: 1 }],
          promise: deferred.promise,
        })
      );
    }
    const response = await fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds().join(',') }),
    }).then((r) => r.json());

    if (response && response.status) {
      const message = response.message || 'Der Griff konnte nicht hinzugefügt werden.';
      if (deferred) deferred.reject(new Error(message));
      if (CartErrorEvent) {
        document.dispatchEvent(new CartErrorEvent({ error: message, code: 'INVALID', detail: { description: response.description } }));
      }
      throw new Error(message);
    }

    if (!deferred) {
      window.location.reload();
      return;
    }
    let cart = null;
    try {
      cart = await fetch(cartUrl(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());
    } catch (e) {}
    deferred.resolve({
      cart: cart ? CartLinesUpdateEvent.createCartFromAjaxResponse(cart) : undefined,
      detail: { items: cart ? cart.items : undefined, source: 'km-cart-griff', sections: response.sections, didError: false },
    });
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest && e.target.closest('[data-km-cg-add]');
    if (!btn) return;
    e.preventDefault();
    const box = btn.closest('[data-km-cart-griff]');
    const status = box && box.querySelector('[data-km-cg-status]');
    const buttons = box ? box.querySelectorAll('[data-km-cg-add]') : [btn];
    // Schritt 227 (A2.10): Statustexte optional aus data-km-cg-busy/-done/-fail (zweite Packung), sonst wie bisher
    const txt = (box && box.dataset) || {};
    buttons.forEach((b) => (b.disabled = true));
    if (status) {
      status.removeAttribute('data-state');
      status.textContent = txt.kmCgBusy || 'Griff wird hinzugefügt …';
    }
    try {
      await addGriff(btn.getAttribute('data-km-cg-add'));
      if (status) status.textContent = txt.kmCgDone || 'Griff wurde hinzugefügt.';
    } catch (err) {
      console.error('[km-cart-griff]', err);
      if (status) {
        status.setAttribute('data-state', 'error');
        status.textContent = txt.kmCgFail || 'Griff konnte nicht hinzugefügt werden. Bitte erneut versuchen.';
      }
      buttons.forEach((b) => (b.disabled = false));
    }
  });
})();
